import React from 'react';
import { 
  FaBuilding,
  FaHandshake,
  FaUserGraduate,
  FaSchool,
  FaUsers,
  FaGlobeAfrica,
  FaGlobeEurope,
  FaUniversity,
  FaHome,
  FaFileContract,
  FaBriefcase,
  FaPassport,
  FaMoneyCheckAlt,
  FaShieldAlt,
  FaRocket,
  FaChartLine,
  FaBullhorn,
  FaHandsHelping,
  FaMapMarkerAlt,
  FaLightbulb,
  FaHeart,
  FaCrown,
  FaChevronRight
} from 'react-icons/fa';
import { 
  FiTarget, 
  FiArrowRight,
  FiGlobe,
  FiAward,
  FiStar
} from 'react-icons/fi';
import './QuiSommesNous.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const QuiSommesNous = () => {
  const sections = [
    {
      title: "Qui sommes-nous ?",
      icon: <FaBuilding />,
      content: "ETEF est une entreprise française basée à Marseille qui accompagne les étudiants africains qui souhaitent poursuivre leurs études supérieures en France.",
      paragraphs: [
        "Nous accompagnons également les universités et écoles africaines qui souhaitent signer des partenariats stratégiques avec des écoles françaises pour se développer et proposer un programme de poursuite d'études supérieures en France à leurs étudiants.",
        "Parallèlement, notre expertise s'étend à l'assistance des écoles françaises dans le recrutement ciblé d'étudiants internationaux, ainsi que dans la mise en place d'un programme d'échange universitaire en Afrique à leurs étudiants.",
        "ETUDIER EN FRANCE - ETEF est une passerelle dans la mobilité étudiante entre les écoles/universités africaines, étudiants africains et écoles françaises."
      ]
    }
  ];

  const services = [
    {
      id: 'african-schools',
      title: "Universités ou écoles africaines",
      icon: <FaUniversity />,
      subtitle: "Nous vous aidons à :",
      items: [
        {
          icon: <FaHandshake />,
          title: "Vous développer",
          description: "Signer des partenariats stratégiques avec des écoles françaises : proposer une poursuite d'étude en France à vos étudiants, proposer une double diplomation, implanter un programme délocalisé d'une école française sur votre campus."
        },
        {
          icon: <FaChartLine />,
          title: "Développer votre notoriété",
          description: "Définir des plans stratégiques qui vous permettront d'attirer plus d'étudiants et de vous démarquer de vos concurrents."
        }
      ],
      color: "african"
    },
    {
      id: 'french-schools',
      title: "Universités ou écoles françaises",
      icon: <FaSchool />,
      subtitle: "Notre rôle est de vous aider à :",
      items: [
        {
          icon: <FaBullhorn />,
          title: "Promouvoir votre école",
          description: "Promouvoir votre école et vos formations dans tous les pays francophones et/ou anglophones d'Afrique."
        },
        {
          icon: <FaUsers />,
          title: "Recruter des étudiants",
          description: "Attirer et recruter de manière ciblée les étudiants africains."
        },
        {
          icon: <FaHandshake />,
          title: "Établir des partenariats",
          description: "Signer des partenariats stratégiques avec des universités ou écoles en Afrique."
        }
      ],
      color: "french"
    },
    {
      id: 'students',
      title: "Étudiants internationaux",
      icon: <FaUserGraduate />,
      subtitle: "Notre rôle est d'aider, orienter et accompagner les étudiants africains dans leurs projets d'étude en France :",
      items: [
        { icon: <FaUniversity />, text: "Admission dans une école ou université française." },
        { icon: <FaHome />, text: "Obtention d'un logement étudiant en France / Garant logement." },
        { icon: <FaPassport />, text: "Accompagnement démarches consulaires." },
        { icon: <FaBriefcase />, text: "Obtention d'un job étudiant en France." },
        { icon: <FaFileContract />, text: "Accompagnement démarches administratives." },
        { icon: <FaMoneyCheckAlt />, text: "Ouverture d'un compte bancaire / Souscription assurance habitation." }
      ],
      color: "student"
    }
  ];

  const stats = [
    { number: "100+", label: "Étudiants accompagnés", icon: <FaUserGraduate />, gradient: "gradient-1" },
    { number: "50+", label: "Écoles partenaires", icon: <FaHandshake />, gradient: "gradient-2" },
    { number: "10+", label: "Pays africains", icon: <FiGlobe />, gradient: "gradient-3" },
    { number: "5+", label: "Villes françaises", icon: <FaMapMarkerAlt />, gradient: "gradient-4" }
  ];

  const values = [
    {
      icon: <FaShieldAlt />,
      title: "Sécurité",
      description: "Un accompagnement sécurisé et conforme aux réglementations",
      color: "value-1"
    },
    {
      icon: <FaRocket />,
      title: "Efficacité",
      description: "Délais optimisés pour toutes les démarches administratives",
      color: "value-2"
    },
    {
      icon: <FaHandsHelping />,
      title: "Accompagnement",
      description: "Suivi personnalisé de A à Z de votre projet",
      color: "value-3"
    },
    {
      icon: <FaGlobeEurope />,
      title: "Expertise internationale",
      description: "Connaissance approfondie des systèmes éducatifs français et africains",
      color: "value-4"
    },
    {
      icon: <FaLightbulb />,
      title: "Innovation",
      description: "Solutions modernes adaptées à l'éducation internationale",
      color: "value-5"
    },
    {
      icon: <FaHeart />,
      title: "Passion",
      description: "Dévouement total à la réussite de chaque projet",
      color: "value-6"
    }
  ];

  return (
    <section className="qsn-sectionbigcontain">
      <Header />
      <section className="qsn-main-section">
        {/* Background decorative elements */}
        <div className="qsn-background-elements">
          <div className="qsn-orb qsn-orb-1"></div>
          <div className="qsn-orb qsn-orb-2"></div>
          <div className="qsn-orb qsn-orb-3"></div>
          <div className="qsn-orb qsn-orb-4"></div>
          <div className="qsn-line qsn-line-1"></div>
          <div className="qsn-line qsn-line-2"></div>
          <div className="qsn-star qsn-star-1"></div>
          <div className="qsn-star qsn-star-2"></div>
          <div className="qsn-star qsn-star-3"></div>
        </div>

        <div className="qsn-container">
          {/* Hero Section */}
          <div className="qsn-hero-section">
            <div className="qsn-hero-content">
              <div className="qsn-hero-badge">
                <FiStar className="qsn-badge-icon" />
                <span>Depuis 2015</span>
              </div>
              <h1 className="qsn-hero-title">
                <span className="qsn-title-underlinedd">Qui</span> sommes-nous ?
              </h1>
              <p className="qsn-hero-subtitle">
                La passerelle d'excellence entre l'éducation africaine et française
              </p>
              
              <div className="qsn-intro-card">
                <div className="qsn-intro-header">
                  <div className="qsn-intro-icon-wrapper">
                    <FaBuilding className="qsn-intro-main-icon" />
                  </div>
                  <h3 className="qsn-intro-title">Notre histoire</h3>
                </div>
                <div className="qsn-intro-body">
                  <p className="qsn-intro-text">{sections[0].content}</p>
                  <div className="qsn-intro-details">
                    {sections[0].paragraphs.map((paragraph, index) => (
                      <div key={index} className="qsn-detail-item">
                        <div className="qsn-detail-icon">
                          <FaChevronRight />
                        </div>
                        <p className="qsn-detail-text">{paragraph}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Stats Section */}
          <div className="qsn-stats-section">
            <div className="qsn-stats-container">
              <div className="qsn-stats-header">
                <h2 className="qsn-stats-title">
                  <FiTarget className="qsn-stats-icon" />
                  Notre impact
                </h2>
                <p className="qsn-stats-subtitle">
                  Des chiffres qui témoignent de notre engagement et de notre expertise
                </p>
              </div>
              <div className="qsn-stats-grid">
                {stats.map((stat, index) => (
                  <div key={index} className={`qsn-stat-card ${stat.gradient}`}>
                    <div className="qsn-stat-glow"></div>
                    <div className="qsn-stat-icon-circle">
                      {stat.icon}
                    </div>
                    <h3 className="qsn-stat-number">{stat.number}</h3>
                    <p className="qsn-stat-label">{stat.label}</p>
                    <div className="qsn-stat-decoration"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Services Section */}
          <div className="qsn-services-section">
            <div className="qsn-section-header">
              <div className="qsn-header-decoration">
                <div className="qsn-header-line"></div>
                <FiAward className="qsn-header-icon" />
                <div className="qsn-header-line"></div>
              </div>
              <h2 className="qsn-section-title">
                Nos domaines d'expertise
              </h2>
              <p className="qsn-section-subtitle">
                Nous connectons les universités africaines, françaises et les étudiants dans un écosystème éducatif complet
              </p>
            </div>

            <div className="qsn-services-grid">
              {services.map((service, index) => (
                <div key={service.id} className={`qsn-service-card qsn-service-${service.color}`}>
                  <div className="qsn-service-glow"></div>
                  <div className="qsn-service-header">
                    <div className="qsn-service-icon-wrapper">
                      <div className="qsn-service-icon-bg"></div>
                      {service.icon}
                    </div>
                    <div className="qsn-service-title-wrapper">
                      <h3 className="qsn-service-title">{service.title}</h3>
                      <p className="qsn-service-subtitle">{service.subtitle}</p>
                    </div>
                  </div>
                  
                  <div className="qsn-service-body">
                    {service.id === 'students' ? (
                      <div className="qsn-service-student">
                        <div className="qsn-student-list">
                          {service.items.map((item, idx) => (
                            <div key={idx} className="qsn-student-item">
                              <div className="qsn-student-icon">
                                {item.icon}
                              </div>
                              <span className="qsn-student-text">{item.text}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="qsn-school-items">
                        {service.items.map((item, idx) => (
                          <div key={idx} className="qsn-school-item">
                            <div className="qsn-school-item-header">
                              <div className="qsn-school-item-icon">
                                {item.icon}
                              </div>
                              <h4 className="qsn-school-item-title">{item.title}</h4>
                            </div>
                            <p className="qsn-school-item-description">{item.description}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="qsn-service-footer">
               
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Values Section */}
          <div className="qsn-values-section">
            <div className="qsn-section-header">
              <h2 className="qsn-section-title">
                <FaCrown className="qsn-section-crown" />
                Nos valeurs fondamentales
              </h2>
              <p className="qsn-section-subtitle">
                Les principes qui guident notre action et façonnent notre excellence
              </p>
            </div>

            <div className="qsn-values-grid">
              {values.map((value, index) => (
                <div key={index} className={`qsn-value-card ${value.color}`}>
                  <div className="qsn-value-glow"></div>
                  <div className="qsn-value-icon-container">
                    <div className="qsn-value-icon-wrapper">
                      {value.icon}
                    </div>
                  </div>
                  <h3 className="qsn-value-title">{value.title}</h3>
                  <p className="qsn-value-description">{value.description}</p>
                  <div className="qsn-value-decoration">
                    <div className="qsn-value-dot"></div>
                    <div className="qsn-value-dot"></div>
                    <div className="qsn-value-dot"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mission Statement */}
          <div className="qsn-mission-section">
            <div className="qsn-mission-card">
              <div className="qsn-mission-glow"></div>
              <div className="qsn-mission-content">
                <div className="qsn-mission-header">
                  <div className="qsn-mission-icon-wrapper">
                    <FaRocket className="qsn-mission-icon" />
                  </div>
                  <div className="qsn-mission-title-wrapper">
                    <h2 className="qsn-mission-title">Notre mission</h2>
                    <p className="qsn-mission-subtitle">L'excellence au service de l'éducation internationale</p>
                  </div>
                </div>
                
                <div className="qsn-mission-body">
                  <p className="qsn-mission-text">
                    Être le pont éducatif entre l'Afrique et la France, en facilitant les échanges universitaires, 
                    en créant des partenariats durables et en accompagnant chaque étudiant vers la réussite de son projet académique en France.
                  </p>
                  
                  <div className="qsn-mission-highlights">
                    <div className="qsn-mission-highlight">
                      <div className="qsn-highlight-icon-wrapper">
                        <FaGlobeAfrica className="qsn-highlight-icon" />
                      </div>
                      <div className="qsn-highlight-content">
                        <h4>Expertise africaine</h4>
                        <p>Connaissance approfondie des systèmes éducatifs africains</p>
                      </div>
                    </div>
                    
                    <div className="qsn-mission-highlight">
                      <div className="qsn-highlight-icon-wrapper">
                        <FaGlobeEurope className="qsn-highlight-icon" />
                      </div>
                      <div className="qsn-highlight-content">
                        <h4>Connaissance française</h4>
                        <p>Maîtrise du système éducatif et administratif français</p>
                      </div>
                    </div>
                    
                    <div className="qsn-mission-highlight">
                      <div className="qsn-highlight-icon-wrapper">
                        <FaHandshake className="qsn-highlight-icon" />
                      </div>
                      <div className="qsn-highlight-content">
                        <h4>Partenariats durables</h4>
                        <p>Création de relations académiques pérennes</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="qsn-mission-footer">
                  <div className="qsn-mission-quote">
                    <FiStar className="qsn-quote-icon" />
                    <p>Transformer les rêves académiques en réalités internationales</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </section>
  );
};

export default QuiSommesNous;